import * as Yup from "yup";
import { ROLES } from "types/user";

export const initialValues = {
  organizationType: "educational",
  organizationName: "",
  primaryContactName: "",
  primaryContactEmail: "",
  secondaryContactName: "",
  secondaryContactEmail: "",
  role: ROLES.ADMIN,
};

export const getValidationSchema = () =>
  Yup.object().shape({
    organizationType: Yup.string().required("This field is required"),
    organizationName: Yup.string().required("This field is required"),
    primaryContactEmail: Yup.string().email("Invalid email address"),
    secondaryContactEmail: Yup.string().email("Invalid email address"),
  });
